import { useFormikContext } from "formik";
import styled from "styled-components";

import { InputProps } from "../../types/inputs";

interface ColorPickerProps extends InputProps {
	value: string;
	dimensions: Dimensions;
	readOnly?: boolean;
}

interface Dimensions {
	width: number;
	height: number;
}

const ColorPickerWrapper = styled.div<Partial<Dimensions>>`
	position: relative;
	width: ${props => props.width || 50}px;
	height: ${props => props.height || 50}px;
	background: ${p => p.theme.background};
	border-radius: ${p => p.theme.borderRadius};
	overflow: hidden;
`;

const ColorPickerOverlay = styled.input`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	cursor: pointer;
`;

const ColorPicker = (props: ColorPickerProps) => {
	const ctx = useFormikContext();

	const name = props.name!,
		value = (ctx.values as any)[props.name!] as string;

	const handleChange = (evt: any) => {
		ctx.setFieldValue(name, evt.target.value);
	};

	return (
		<ColorPickerWrapper width={props.dimensions?.width} height={props.dimensions?.height}>
			<ColorPickerOverlay
				type="color"
				value={value}
				onChange={handleChange}
			/>
		</ColorPickerWrapper>
	);
};

export default ColorPicker;
